// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const ProductCollectionServiceService = {};

ProductCollectionServiceService.postProductCollection = function (data) {
  // console.log("🚀 ~ postProductCollectionService qwerty:", data);
  return lossClient({
    url: "/subproductcollection/add",
    method: "post",
    data: {
      SubProductTypeId: data.SubProductTypeId,
      IsDCPhoneRemind1: data.IsDCPhoneRemind1,
      DCPhoneRemind1: data.DCPhoneRemind1,
      IsDCPhoneRemind2: data.IsDCPhoneRemind2,
      DeskCollPhoneRemind2: data.DeskCollPhoneRemind2,
      IsSMSRemind1: data.IsSMSRemind1,
      SMSRemind1: data.SMSRemind1,
      IsSMSRemind2: data.IsSMSRemind2,
      SMSRemind2: data.SMSRemind2,
      IsEmailRemind1: data.IsEmailRemind1,
      EmailRemind1: data.EmailRemind1,
      IsEmailRemind2: data.IsEmailRemind2,
      EmailReminder2: data.EmailReminder2,
      IsSP1Automatic: data.IsSP1Automatic,
      LengthSP1Process: data.LengthSP1Process,
      IsSP2Automatic: data.IsSP2Automatic,
      LengthSP2Process: data.LengthSP2Process,
      IsSP3Automatic: data.IsSP3Automatic,
      LengthSP3Process: data.LengthSP3Process,
      DPDFieldColl: data.DPDFieldColl,
      DPDtoRAL: data.DPDtoRAL,
      RALPeriod: data.RALPeriod,
      RALExtend: data.RALExtend,
      MaxPTPDay: data.MaxPTPDay,
      InventoryDay: data.InventoryDay,
      UserId: data.userId,
    },
  });
};

ProductCollectionServiceService.editProductCollection = function (data) {
  // console.log("🚀 ~editProductCollection serviceeeee:", data);
  return lossClient({
    url: "/SubProductCollection/edit",
    method: "put",
    headers: {
      "x-RequestId": data.SubProductTypeId,
    },
    data: {
      IsDCPhoneRemind1: data.IsDCPhoneRemind1,
      DCPhoneRemind1: data.DCPhoneRemind1,
      IsDCPhoneRemind2: data.IsDCPhoneRemind2,
      DeskCollPhoneRemind2: data.DeskCollPhoneRemind2,
      IsSMSRemind1: data.IsSMSRemind1,
      SMSRemind1: data.SMSRemind1,
      IsSMSRemind2: data.IsSMSRemind2,
      SMSRemind2: data.SMSRemind2,
      IsEmailRemind1: data.IsEmailRemind1,
      EmailRemind1: data.EmailRemind1,
      IsEmailRemind2: data.IsEmailRemind2,
      EmailReminder2: data.EmailReminder2,
      IsSP1Automatic: data.IsSP1Automatic,
      LengthSP1Process: data.LengthSP1Process,
      IsSP2Automatic: data.IsSP2Automatic,
      LengthSP2Process: data.LengthSP2Process,
      IsSP3Automatic: data.IsSP3Automatic,
      LengthSP3Process: data.LengthSP3Process,
      DPDFieldColl: data.DPDFieldColl,
      DPDtoRAL: data.DPDtoRAL,
      RALPeriod: data.RALPeriod,
      RALExtend: data.RALExtend,
      MaxPTPDay: data.MaxPTPDay,
      InventoryDay: data.InventoryDay,
      UserId: data.userId,
    },
  });
};

ProductCollectionServiceService.getProductCollectionList = function (
  userInput
) {
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/SubProductCollection/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod,
    method: "get",
  });
};

ProductCollectionServiceService.getProductCollectionApprovalList = function (
  userInput
) {
  // console.log("🚀 ~ getProductCollectionApprovalList:", userInput);
  var userInputIndex = userInput.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({
    url:
      "/SubProductCollection/approvalItems/?pageSize= " +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.prodCod,
    method: "get",
  });
};

ProductCollectionServiceService.putProductCollectinRequest = function (data) {
  // console.log("🚀 ~putProductCollectinRequest service:", data);
  return lossClient({
    url: `/subproductcollection/request`,
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      Request: data.Request,
      note: data.note,
      userId: data.userId,
    },
  });
};

ProductCollectionServiceService.getProductCollectionApproval = function (data) {
  return lossClient({
    url: `/subproductcollection/approve`,
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      note: data.note,
      userId: data.userId,
    },
  });
};

ProductCollectionServiceService.getProductCollectionReturn = function (data) {
  // console.log("🚀 ~ getProductCollectionReturnqwert data:", data.note);
  return lossClient({
    url: `/SubProductCollection/return`,
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      note: data.note,
      userId: data.userId,
    },
  });
};

ProductCollectionServiceService.getProductCollectionReject = function (data) {
  // console.log("🚀 ~ getProductCollectionReject data:", data);
  return lossClient({
    url: `/SubProductCollection/reject`,
    method: "put",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      note: data.note,
      userId: data.userId,
    },
  });
};

ProductCollectionServiceService.deleteProductCollection = function (data) {
  // console.log(
  //   "🚀 ~ ProductCollectionServiceService.deleteProductCollection ~ data:",
  //   data
  // );
  return lossClient({
    url: `/SubProductCollection/delete`,
    method: "delete",
    headers: {
      "x-RequestId": data.id,
    },
    data: {
      UserId: data.userId,
    },
  });
};

ProductCollectionServiceService.uploadProductCollection = function (data) {
  // console.log('uploadProductCollection',data);
  
  return lossClient({
    url: `/subproductcollection/Upload-SubProductCollection-csv`,
    method: "post",
    headers: {},
    data: data,
  });
};

export default ProductCollectionServiceService;
